import { type Ref, computed, unref, useStore } from "@nuxtjs/composition-api";

import { getProductDetailsStore } from "@/store/product-details";
import { getRetailerProductsStore } from "@/store/retailer-products";

/**
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 *
 * @function useProductDetails
 * @param    {Ref<string> | string} productDetailId
 * @desc     A composable that returns a product detail from the product details store
 *
 * @summary  Composable used to retrieve a product detail.
 *
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 */
export const useProductDetails = (productDetailId: Ref<string> | string) => {
  const store = useStore();

  const productDetails = computed(() => getProductDetailsStore(store).productDetails[unref(productDetailId)]);
  const catalogRetailerProductId = computed(() => productDetails.value?.catalogRetailerProductId ?? "");
  const catalogRetailerProduct = computed(
    () => getRetailerProductsStore(store).retailerProducts[catalogRetailerProductId.value],
  );

  return { productDetails, catalogRetailerProductId, catalogRetailerProduct };
};
